// main.js
import Vue from "vue";
import VueMeta from "vue-meta";
import "@/plugins/vuetify";
import App from "@/App.vue";
import router from "@/router";
import store from "@/stores";
import "@/registerServiceWorker";
import VueResource from "vue-resource";
import * as uiv from "uiv";

// import {
//   ImagePlugin
// } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap-vue/dist/bootstrap-vue.css";

import "cropperjs/dist/cropper.min.css";
import "@/scss/main.scss";

import "@/assets/fonts/avenir.css";

// import "@/assets/fontawesome-free-5.1.0-web/css/all.css";
import Datetime from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
import VeeValidate from "vee-validate";
import AsyncComputed from "vue-async-computed";
import Vue2Filters from "vue2-filters";
import * as VueGoogleMaps from "vue2-google-maps";
// import VueLazyload from "vue-lazyload";
import Configs from "./config.js";
import customTimingMessage from "./methods/Validation";
import InfiniteLoading from "vue-infinite-loading";

// import AudioRecorder from "vue-audio-recorder";
import VueOffline from "vue-offline";
import VueApexCharts from "vue-apexcharts";
import VueSignaturePad from "vue-signature-pad";
import "./directives";

import VueSkeletonLoader from 'skeleton-loader-vue';
Vue.component('vue-skeleton-loader', VueSkeletonLoader);

// for doctor dashboard calendar widget
import VCalendar from 'v-calendar';
const CrossStorageClient = require("cross-storage").CrossStorageClient;
const storage = new CrossStorageClient(
  `${Configs.NEW_BASE_URL}cross-storage-hub`
);
Vue.use(VCalendar, {
  componentPrefix: 'vc',  // Use <vc-calendar /> instead of <v-calendar />
});

// for share link
import VueSocialSharing from 'vue-social-sharing'
Vue.use(VueSocialSharing);

import VueScreen from "vue-screen";
Vue.use(VueScreen);

Vue.use(VueMeta);

// FOR FACEBOOK PIXEL
import VueFacebookPixel from 'vue-facebook-pixel'

Vue.use(VueFacebookPixel, {
  debug: true,
  router
});

// freeze frame for gifs
import VueFreezeframe from 'vue-freezeframe';
Vue.use(VueFreezeframe);

// viewport observer
import VueObserveVisibility from 'vue-observe-visibility'
Vue.use(VueObserveVisibility)

Vue.analytics.fbq.init(Configs.FACEBOOK_PIXEL_KEY, {});

// FOR GTAG
import VueGtag from 'vue-gtag-conversion';

Vue.use(VueGtag, {
  id: Configs.GOOGLE_AD_WORDS_KEY,
  enabled: true,
  debug: true,
});

//Vue.use(ImagePlugin);
Vue.use(uiv);
Vue.component("apexchart", () =>
  import(/* webpackChunkName: "chunk-vue-apexcharts" */ "vue-apexcharts")
);
Vue.use(VueOffline);
// Vue.use(SuiVue);
// Vue.use(AudioRecorder);
Vue.use(VueGoogleMaps, {
  load: {
    // Google API key
    key: Configs.MAP_API_KEY,
    // Enable more Google Maps libraries here
    libraries: "places"
  }
});
VeeValidate.use(({ ErrorBag }) => {
  const msg = customTimingMessage(ErrorBag);
  return msg;
});
VeeValidate.Validator.extend('no_zero_in_start', {
  getMessage: field => 'The ' + field + ' field has to start with a number other than 0',
  validate: val => {
    return val[0] !== '0'
  }
});
// Vue.use(VueLazyload);
Vue.use(Vue2Filters);
Vue.use(
  VeeValidate,
  {
    inject: false
  },
  {
    events: "change|blur|input"
  }
);
Vue.use(Datetime);

Vue.use(AsyncComputed);
Vue.use(VueResource);
Vue.use(VueSignaturePad);
import Swal from "sweetalert2";

import VueAnalytics from 'vue-analytics';
console.log('Analytics tracker ',Configs.GOOGLE_ANALYTICS_TRACKER_ID)
if(process.env.NODE_ENV === 'production'){
  Vue.use(VueAnalytics, {
    id: Configs.GOOGLE_ANALYTICS_TRACKER_ID,
    router
  });
}

import VueTour from 'vue-tour'

require('vue-tour/dist/vue-tour.css')
Vue.use(VueTour)

Vue.http.interceptors.push((request, next) => {
  if (localStorage.token) {
    request.headers.set("Authorization", `Bearer ${localStorage.token}`);
  }
  request.headers.set("Accept", "application/json");
  if (request.params.loader == false) {
    // loader will not show if {loader: false} is passed in params in options
    // delete loader key from params, so that it is not sent to the api
    delete request.params.loader;
  } else {
    // show loader only if loader key does not exist or is not equal to false
    store.commit("general/showLoading");
  }

  function openSwalMessage(message) {
    Swal.fire({
      toast: true,
      html: "<p> <b>" + message + "</b></p>",
      showCancelButton: false,
      // cancelButtonText: "<i class='glyphicon glyphicon-remove'></i>",
      showConfirmButton: false,
      position: "bottom",
      // allowOutsideClick: false,
      // imageUrl: "/images/icons/error.png",
      // imageWidth: 50,
      // imageHeight: 55,
      customClass: "bottom-swal",
      timer: 6000
    });
  }
  next(response => {
    if (response.status == 401) {
      openSwalMessage(response.body.message);
      storage
        .onConnect()
        .then(() => {
          return storage.clear();
        })
        .catch(err => {
          console.log(err);
        })
        .then(() => {
          storage.close();
          store.dispatch("user/logout");
          window.location.href = Configs.NUXT_URL;
        });
    } else if (
      (response.status != 200 &&
        response.status != 201 &&
        response.status != 0) ||
      response.body.status == false
    ) {
      if (request.snackbarStatus && request.snackbarStatus != true || request.params && request.params.snackbarStatus && request.params.snackbarStatus === false) {
        let message =
          response.body.message ||
          "There is some internal Error Please try after some time";
        openSwalMessage(message);
      }
    }
    store.commit("general/hideLoading");
  });
});

import VueSweetalert2 from "vue-sweetalert2";
// If you don't need the styles, do not connect
import "sweetalert2/dist/sweetalert2.min.css";

Vue.use(VueSweetalert2);

import firebase from "firebase/app";
let config = {
  apiKey: Configs.FIREBASE_API_KEY,
  authDomain: Configs.FIREBASE_AUTH_DOMAIN,
  databaseURL: Configs.FIREBASE_DB_URL
};
window.firebase = firebase.initializeApp(config);

Vue.use(InfiniteLoading);

Vue.config.productionTip = false;
//Vue.config.performance = process.env.NODE_ENV !== "production";
Configs.SOCKET_URL;
// const connection = io.connect(Configs.SOCKET_URL);

let pathNames = ["register.doctor.qualifications"];
let alliedPathNames = ["register.allied.allied_qualifications"];

export const bus = new Vue();

router.beforeEach((to, from, next) => {
  let userDetails = store.getters["user/getUserDetails"];
  let role = localStorage.getItem("currentRole");
  if(to.path =='/') {
    next(false);
    return;
  }
  bus.$emit("GLOBAL_ROUTE_FROM", from.name);
  if (
    userDetails.reg_status == "REJECT" &&
    role == "doctor" &&
    !pathNames.includes(to.name)
  ) {
    next({
      name: "register.doctor.qualifications"
    });
  } else next();
  if (
    userDetails.allied && userDetails.allied.reg_status == "REJECT" &&
    role == "allied" &&
    !alliedPathNames.includes(to.name)
  ) {
    next({
      name: "register.allied.allied_qualifications"
    });
  } else next();
  if (
    userDetails.hospital_reg_status == "REJECT" &&
    role == "hospital"
  ) {
    next({
      name: "register.hospital.center-details"
    });
  } else next();
});

Vue.prototype.$transport = require("./transport").default;
if (localStorage.getItem("token")) {
  Vue.prototype.$transport.init();
}

Vue.prototype.$notifier = require("./notifier").default;
// Vue.prototype.$notifier.init();
// Vue.notifier.call('in');

export default new Vue({
  router,
  store,
  render: h => h(App),
  data() {
    return {
      validatorError: []
    };
  },
  watch: {
    validatorError: newValue => {
      if (
        newValue.length >= 1 &&
        document.getElementsByName(newValue[0].field)[0]
      )
        document.getElementsByName(newValue[0].field)[0].scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "nearest"
        });
    }
  },
  mounted() {
    this.validatorError = this.$validator.errors.items;
  }
}).$mount("#app");
